import React from 'react';
import {getPorts} from 'providers/ferries/api';
import createSearchMaskStore from './components/FerrySearchMask/FerrySearchMaskStore';
import {Hero, FooterSection} from 'components/LandingPage';
import FerrySearchMask from './components/FerrySearchMask';
import ManageBookingTouchPoints from './components/ManageBookingTouchPoints';
import LatestUpdates from './components/LatestUpdates';
import Benefits from './components/Benefits';
import TrustedPartners from './components/TrustedPartners';
import Destinations from './components/Destinations';
import PopularRoutes from './components/PopularRoutes';
import Testimonials from './components/Testimonials';
import Articles from './components/Articles';
import FerryPartner from 'ferries/helpers/FerryPartner';
import EspaBanner from './components/EspaBanner';
import InView from 'helpers/InView';
import {hero, latestUpdates, benefitsAndUpsells, companyPartners,
  destinations, routes, testimonials, articles, manageBooking} from 'ferries/Home/content';
import {isFerryPartner} from 'ferries/helpers/common';
import {isFerryscanner, isAffiliate, language} from 'helpers/stableValues';
import {ferryPartnerTranslations} from 'ferries/helpers/translations';

const searchMaskStore = createSearchMaskStore({getPorts});

const Page = () => (
  <div className="bg-white">
    <Hero
      isHomePage
      heroImage={hero.img}
      title={hero.title}
      slogan={hero.body}
    >
      <FerrySearchMask isStandard store={searchMaskStore} classes="home" />
    </Hero>
    {latestUpdates && <InView><LatestUpdates latestUpdates={latestUpdates} /></InView>}
    {benefitsAndUpsells && <InView><Benefits benefitsAndUpsells={benefitsAndUpsells} /></InView>}
    <InView><TrustedPartners companyPartners={companyPartners} /></InView>
    {manageBooking && <InView>
      <ManageBookingTouchPoints manageBooking={manageBooking} bgColor="bg-snow" touchPointClasses='mb-5' />
    </InView>}
    <InView><Destinations destinations={destinations} /></InView>
    {routes && <InView><PopularRoutes routes={routes} /></InView>}
    {testimonials && <InView><Testimonials testimonials={testimonials} /></InView>}
    {articles && <InView><Articles articles={articles} /></InView>}
    {!isAffiliate && isFerryscanner && ['el', 'en'].includes(language) &&
      <InView><EspaBanner language={language} /></InView>}
    {isFerryPartner && <InView><FerryPartner translations={ferryPartnerTranslations} /></InView>}
    <InView><FooterSection /></InView>
  </div>
);

export default Page;
